// @flow

import React, { useState } from 'react'

import './SourceTypeFilter.css'

type Props = {
  changeFilter: Function,
  currentFilter: Function
}

function SourceTypeFilter ({ changeFilter, currentFilter }: Props) {
  const filter = currentFilter && currentFilter.alt ? currentFilter.alt : ''
  const [selected, setSelected] = useState(filter)

  const handleClick = (type) => {
    if (selected === type) {
      setSelected('')
      changeFilter(Object.assign({}, currentFilter, { alt: '' }))
      return
    }
    setSelected(type)
    changeFilter(Object.assign({}, currentFilter, { alt: type }))
  }

  return (
    <>
      <div className='Header'>
        <div>
          <span className='HeaderText'>Filter by Source</span>
        </div>
      </div>

      <div className='FilterByContent'>
        <div className='FilterByRow'>
          <div className='FilterByColumn'>
            <ul className='SourceTypeItemContainer'>
              <li
                className={(selected === '') ? 'SourceTypeItem selected' : 'SourceTypeItem'}
                onClick={() => handleClick('')}>All Messages</li>
              <li
                key='outgoing'
                className={(selected === 'OUTGOING') ? 'SourceTypeItem selected' : 'SourceTypeItem'}
                onClick={() => handleClick('OUTGOING')}>Outgoing</li>
              <li
                key='incoming'
                className={(selected === 'INCOMING') ? 'SourceTypeItem selected' : 'SourceTypeItem'}
                onClick={() => handleClick('INCOMING')}>Incoming</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default SourceTypeFilter
